<template>
	<div class="divContainer">
		<div class="divContainer1">
			<span class="setTitle">全局设置</span>
			<a-radio-group v-model:value="useopenGlobal">
				<a-radio :value="1">直接打开</a-radio>
				<a-radio :value="2">关闭直接打开</a-radio>
			</a-radio-group>
			<span class="setDesc">所有二维码内有效</span>
		</div>
		<div class="divContainer1">
			<span class="setTitle">独立设置</span>
			<a-radio-group name="radioGroupL" v-model:value="useopenLocal">
				<a-radio @click="setUseopenLocal(1)" class="radioitem" :value="1">直接打开</a-radio>
				<a-radio @click="setUseopenLocal(2)" class="radioitem" :value="2">关闭直接打开</a-radio>
			</a-radio-group>
			<span class="setDesc">当前二维码内有效</span>
		</div>
		<p class="setTips" @click="setok()">
			<ExclamationCircleOutlined />
			全局设置不会改变独立设置，独立设置保持最高优先级，如无特殊需求，不要使用独立设置
		</p>
		
	</div>
</template>

<script>
	import { defineComponent, ref ,watch,getCurrentInstance} from 'vue';
	import {
		ExclamationCircleOutlined
	} from '@ant-design/icons-vue';
	export default ({
		name: 'openset',
		props:{
			openGlobal:Number,
			openLocal:Number
		},
		components: {
			ExclamationCircleOutlined
		},
		data(){
			return {
				useopenLocal:this.openLocal,
				useopenGlobal:this.openGlobal,
			}
		},
		watch:{
			openGlobal:{
				handler(newval, oldval) {
					this.useopenGlobal=newval;
					
				}
			},
			openLocal:{
				handler(newval, oldval) {
					this.useopenLocal=newval;
				}
			},
			useopenGlobal:{
				handler(newval, oldval) {
					this.$emit('setopenData',{
						useopenGlobal:this.useopenGlobal,
						useopenLocal:this.useopenLocal,
					})
				}
			},
			useopenLocal:{
				handler(newval, oldval) {
					this.$emit('setopenData',{
						useopenGlobal:this.useopenGlobal,
						useopenLocal:this.useopenLocal,
					})
				}
			}
		},
		methods:{
			setUseopenLocal(e){
				if(this.useopenLocal==e){
					this.useopenLocal=0;
				}
			}
			
		}
	});
	
</script>

<style scoped>
	.mbm_move_model_center_footer .ant-btn-primary:hover, .ant-btn-primary:focus{
		background: #40a9ff !important;
		border-color: #40a9ff !important;
	}
	.setTips {
		color: #ff8a00;
		margin-bottom: 0;
		line-height: 30px;
		margin-top: 55px;
	}

	.setTips :deep(.anticon) {
		font-size: 14px;
	}

	.setDesc {
		color: rgba(0, 0, 0, .6);
		margin-left: 40px;
	}

	.radioitem {
		width: 88px;
		margin-right: 8px;
		font-weight: bold;
		color: rgba(0, 0, 0, .6);
	}

	.setTitle {
		font-size: 14px;
		color: #000;
		display: inline-block;
		width: 120px;
		font-weight: bold;
	}

	.divContainer1 {
		width: 598px;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.divContainer {
		max-width: 602px;
		width: 650px;
		height: 174px;
		padding: 2px;
	}
</style>
